import { render, staticRenderFns } from "./TTButton.vue?vue&type=template&id=5b7b2d8a&scoped=true"
import script from "./TTButton.vue?vue&type=script&lang=js"
export * from "./TTButton.vue?vue&type=script&lang=js"
import style0 from "./TTButton.vue?vue&type=style&index=0&id=5b7b2d8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b2d8a",
  null
  
)

export default component.exports